<template>
	<div class="gp-information" style="margin-bottom: 20px;">
		<detail-nav title="申请类目" background="#FFFFFF" paddingTop="15px" paddingLeft="25px"
			@navigateBack="gpNavigateback">
		</detail-nav>
		<div class="gp-layer-body">
			<div class="cate-apply-main">
				<div class="cate-apply-one">
					<div class="cate-apply-tit">经营类目：</div>
					<div class="cate-apply-view" style="margin-left: 20px;">
						<div class="cate-apply-list" style="margin-right: 12px;">
							<div v-for="(item,index) in cate_big" class="cate-apply-item" :class="{'cate-apply-item-act':index==big_index}" @click="changebig(index)">
								<div class="cate-apply-item-name">{{item.name}}</div>
								<img v-if="index==big_index" class="cate-apply-item-icon" src="../../assets/img/category/right-blue.png">
							</div>
						</div>
						<div class="cate-apply-list">
							<div v-for="(item,index) in cate_fir" class="cate-apply-item" :class="{'cate-apply-item-act':index==fir_index}" @click="changefir(index)">
								<div class="cate-apply-item-name">{{item.name}}</div>
							</div>
							
						</div>
					</div>
				</div>
				<div class="cate-apply-one">
					<div class="cate-apply-tit">类目资质与保证金：</div>
					<div class="cate-apply-qual">
						<div class="cate-apply-qual-tit">
							<span style="color: #F56C6C;margin-right: 5px;">*</span>
							商品类目
						</div>
						<div class="cate-apply-qual-right">
							{{cate_big[big_index].name}}>{{cate_fir[fir_index].name}}
						</div>
					</div>
					<div class="cate-apply-qual" style="margin-right: 25px;" v-if="money > 0">
						<div class="cate-apply-qual-tit">
							<span style="color: #F56C6C;margin-right: 5px;">*</span>
							类目保证金
						</div>
						<div class="cate-apply-qual-right">
							¥{{money}}
						</div>
					</div>
					<div class="cate-apply-qual">
						<div class="cate-apply-qual-tit">
							<span style="color: #F56C6C;margin-right: 5px;">*</span>
							类目资质
						</div>
						<div class="cate-apply-qual-right" v-if="quals.length==1">
						    当前类目无需额外资质证明
						</div>
						<div v-if="quals.length>1">
						    <div v-for="(item,index) in quals" :key="index">
								<div v-if="item.is_need==1">
									<div v-for="(item_,index_) in item.quals" :key="index_">
										<el-upload class="upload-image" ref="upload_img"
										    :headers="upload.headers"
											:action="upload.url" :show-file-list="false"
										    :on-success="getfile" :multiple="false" @click.native="chose_qual(index,index_)"
										    :before-upload="beforeAvatarUpload" :on-progress="onthecross"
										    >
										    
										    <img class="cover_img" v-if="item_.imgid>0" :src="item_.newurl" alt="" />
										    <div v-else class="uploader-div">
										        <i class="el-icon-plus"></i>
										    </div>
										</el-upload>
										<div class="cate-apply-qual-desc">
											请上传企业《{{item_.name}}》彩色照片，<span class="cate-apply-qual-exp" @click="open_qual_img(index,index_)">图片样例>></span><br>
											请上传证件清晰彩色原件扫描件或数码拍摄照片大小2MB以内的png、jpg、jpeg格式的图片
										</div>
									</div>
								</div>
						    </div>
						</div>
					</div>
				</div>
			</div>
			<div class="cate-apply-money">
				<div class="cate-apply-money-info">
					<!-- <div class="cate-apply-money-need">
						合计需支付保证金：<span class="cate-apply-money-need-num">¥{{pay_money}}</span>
					</div> -->
					<div class="cate-apply-money-need">
						合计需支付保证金：<span class="cate-apply-money-need-num">限时免费</span>
						<span v-if="pay_money > 0" style="font-size: 14px;font-family: PingFangSC, PingFang SC;color: #999999;text-decoration: line-through;margin-left:5px">¥{{pay_money}}</span>
					</div>
					<div class="cate-apply-money-other">
						<div class="cate-apply-money-one">
							应付保证金：¥{{money}}
						</div>
						<div class="cate-apply-money-one">
							已支付保证金：¥{{old_money}}
						</div>
					</div>
				</div>
				<div class="cate-apply-operate">
					<!-- <el-button @click="apply" :disabled="btndis" class="cate-apply-money-btn" type="primary">支付并添加类目</el-button> -->
					<el-button @click="apply" :disabled="btndis" class="cate-apply-money-btn" type="primary">添加类目</el-button>
					<div class="cate-apply-checkbox">
						<el-checkbox v-model="agree_protocol"></el-checkbox>
						<p>本店承诺保证所经营的类型符合<span @click="previewPact(0)">《电子商务法》</span>以及<span @click="previewPact(1)">《网络交易监督管理办法》</span>的相关规定</p>
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog class="pay-dialog" width="800px" title="保证金缴纳" :visible.sync="showPreviewDialog"
			:before-close="closePreviewDialog" :close-on-click-modal="false" :close-on-press-escape="false">
			<div style="height: 520px;">
			<el-tabs v-model="type" type="card" @tab-click="handleClick">
				<el-tab-pane label="公对公转账 (线下)" name="offline">
					<div class="my-form_child">
						<div class="put-item">
							<p>您需先汇款至以下账户，汇款成功后填写汇款信息。</p>
							<p>收款方户名：北京爱群游网络信息技术有限公司</p>
							<p>收款方开户行：招商银行石家庄分行广安支行</p>
							<p 
							  v-clipboard:copy="'755945898210301'"
							  v-clipboard:success="onCopySuccess"
							  v-clipboard:error="onCopyError">收款方账户：755945898210301 <span class="copy">复制</span></p>
						</div>
						
						<div class="pie">
							<p>付款方信息</p>
						</div>
						<div class="pay-item">
							<div class="my-label">
								<div class="my-label_title">
									<span>*</span>付款开户名
								</div>
								<div class="my-label_content">
									<el-input v-model="myForm.accountName" maxlength="50" placeholder="请输入户名" style="width: 554px;"></el-input>
								</div>
							</div>
						
							<div class="my-label">
								<div class="my-label_title">
									<span>*</span>付款开户号
								</div>
								<div class="my-label_content">
									<el-input v-model="myForm.account" maxlength="25" placeholder="请输入付款账号" style="width: 554px;"></el-input>
								</div>
							</div>
						
							<div class="my-label">
								<div class="my-label_title">
									<span>*</span>付款日期
								</div>
								<div class="my-label_content">
									<el-date-picker style="width: 554px;" v-model="myForm.accountDate" type="date" :editable="false" placeholder="选择日期">
									</el-date-picker>
								</div>
							</div>
							
							<div class="my-label">
								<div class="my-label_title">
									<span>*</span>充值金额
								</div>
								<div class="my-label_content">
									<div class="pay-dialog-money">¥{{pay_money}}</div>
								</div>
							</div>
							<div class="money-tips">注：线下转账付款后，客服人员会在24小时内完成审核，请及时打款，以免影响服务类目的开通</div>
							<div class="my-label">
								<el-button class="margin-left-80" type="primary" @click="offlinePay" :disabled="btndis">确认提交</el-button>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="微信支付 (线上)" name="wxpay">
					<div class="wxpay-qrcode">
						<img v-if="previewImageUrl" :src="previewImageUrl" style="width: 170px;height: 170px;object-fit: contain;" />
					</div>
					<div class="wxpay-res-div">
						
					
					<div class="wxpay-res">
						<img class="wxpay-icon" src="../../assets/img/category/wxpay.png" alt="">
						<div class="wxpay-txt">
							{{is_success?'支付成功，3秒后自动跳转':'微信支付'}}
						</div>
					</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			</div>
		</el-dialog>
		<el-dialog class="my-dialog" :title="pact0.title" :visible.sync="showPact0" :show-close="false" :before-close="close">
			<div class="my-date">
				<span>更新时间：{{pact0.entry_time}}</span>
				<span class="margin-left-30">生效时间：{{pact0.version_time}}</span>
			</div>
			<div class="my-editor">
				<quill-editor class="myQuillEditor" ref="text" v-model="pact0.content" disabled="disabled" />
			</div>
			<div slot="footer">
				<el-button type="primary" @click="close">知道了</el-button>
			</div>
		</el-dialog>
		<el-dialog class="my-dialog" :title="pact1.title" :visible.sync="showPact1" :show-close="false" :before-close="close">
			<div class="my-date">
				<span>更新时间：{{pact1.entry_time}}</span>
				<span class="margin-left-30">生效时间：{{pact1.version_time}}</span>
			</div>
			<div class="my-editor">
				<quill-editor class="myQuillEditor" ref="text" v-model="pact1.content" disabled="disabled" />
			</div>
			<div slot="footer">
				<el-button type="primary" @click="close">知道了</el-button>
			</div>
		</el-dialog>
		<preview-imgs title="资质样例" :show="showQualExpImg" :imgs="showQualImgs" :imgs_index="qualImgIndex" @close="closePreview" @change="changeImgsIndex"></preview-imgs>
	</div>
	
</template>

<script>
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	import {
		getCateApplyInfo,
		cateApply,
		cateApplyFree,
		getCateInfo,
		getOrder
	} from '@/api/goods';
	import {
		quillEditor
	} from 'vue-quill-editor';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import oss from '@/utils/oss';
	import previewImgs from '@/components/preview-imgs.vue';
	import detailNav from '@/components/detail-nav.vue';
	import Vue from 'vue';
	import VueClipboard from 'vue-clipboard2';
	Vue.use(VueClipboard);
	var timekey;
	export default {
		data() {
			return {
				order_sn:'',
				previewImageUrl:'',
				showPreviewDialog:false,
				is_success:false,
				myForm: {
					account: '',
					accountName: '',
					accountDate: ''
				},
				type:'offline',//'wxpay'
				showQualExpImg:false,
				btndis:false,
				cate_big:[],
				big_index:0,
				cate_fir:[],
				fir_index:0,
				old_money:1000,
				money:2000,
				pay_money:1000,
				quals:[],
				qual_index:-1,
				cate_index:-1,
				
				showQualImgs:[],
				qualImgIndex:0,
				
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] : ''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Upload/oneToMid'
				},
				
				agree_protocol: false,
				showPact0: false,
				showPact1: false,
				pact0: {
					title: '中华人民共和国电子商务法',
					entry_time: '2019年1月1日',
					version_time: '2022年6月9日',
					content: '<h2>（2018年8月31日第十三届全国人民代表大会常务委员会第五次会议通过）</h2><br/><h2>第一章　总则</h2><p>第一条　为了保障电子商务各方主体的合法权益，规范电子商务行为，维护市场秩序，促进电子商务持续健康发展，制定本法。</p><p>第二条　中华人民共和国境内的电子商务活动，适用本法。</p><p>本法所称电子商务，是指通过互联网等信息网络销售商品或者提供服务的经营活动。</p><p>法律、行政法规对销售商品或者提供服务有规定的，适用其规定。金融类产品和服务，利用信息网络提供新闻信息、音视频节目、出版以及文化产品等内容方面的服务，不适用本法。</p><p>第三条　国家鼓励发展电子商务新业态，创新商业模式，促进电子商务技术研发和推广应用，推进电子商务诚信体系建设，营造有利于电子商务创新发展的市场环境，充分发挥电子商务在推动高质量发展、满足人民日益增长的美好生活需要、构建开放型经济方面的重要作用。</p><p>第四条　国家平等对待线上线下商务活动，促进线上线下融合发展，各级人民政府和有关部门不得采取歧视性的政策措施，不得滥用行政权力排除、限制市场竞争。</p><p>第五条　电子商务经营者从事经营活动，应当遵循自愿、平等、公平、诚信的原则，遵守法律和商业道德，公平参与市场竞争，履行消费者权益保护、环境保护、知识产权保护、网络安全与个人信息保护等方面的义务，承担产品和服务质量责任，接受政府和社会的监督。</p><p>第六条　国务院有关部门按照职责分工负责电子商务发展促进、监督管理等工作。县级以上地方各级人民政府可以根据本行政区域的实际情况，确定本行政区域内电子商务的部门职责划分。</p><p>第七条　国家建立符合电子商务特点的协同管理体系，推动形成有关部门、电子商务行业组织、电子商务经营者、消费者等共同参与的电子商务市场治理体系。</p><p>第八条　电子商务行业组织按照本组织章程开展行业自律，建立健全行业规范，推动行业诚信建设，监督、引导本行业经营者公平参与市场竞争。</p><h2>第二章　电子商务经营者</h2><h3>第一节　一般规定</h3><p>第九条　本法所称电子商务经营者，是指通过互联网等信息网络从事销售商品或者提供服务的经营活动的自然人、法人和非法人组织，包括电子商务平台经营者、平台内经营者以及通过自建网站、其他网络服务销售商品或者提供服务的电子商务经营者。</p><p>本法所称电子商务平台经营者，是指在电子商务中为交易双方或者多方提供网络经营场所、交易撮合、信息发布等服务，供交易双方或者多方独立开展交易活动的法人或者非法人组织。</p><p>本法所称平台内经营者，是指通过电子商务平台销售商品或者提供服务的电子商务经营者。</p><p>第十条　电子商务经营者应当依法办理市场主体登记。但是，个人销售自产农副产品、家庭手工业产品，个人利用自己的技能从事依法无须取得许可的便民劳务活动和零星小额交易活动，以及依照法律、行政法规不需要进行登记的除外。</p><p>第十一条　电子商务经营者应当依法履行纳税义务，并依法享受税收优惠。</p><p>依照前条规定不需要办理市场主体登记的电子商务经营者在首次纳税义务发生后，应当依照税收征收管理法律、行政法规的规定申请办理税务登记，并如实申报纳税。</p><p>第十二条　电子商务经营者从事经营活动，依法需要取得相关行政许可的，应当依法取得行政许可。</p><p>第十三条　电子商务经营者销售的商品或者提供的服务应当符合保障人身、财产安全的要求和环境保护要求，不得销售或者提供法律、行政法规禁止交易的商品或者服务。</p><p>第十四条　电子商务经营者销售商品或者提供服务应当依法出具纸质发票或者电子发票等购货凭证或者服务单据。电子发票与纸质发票具有同等法律效力。</p><p>第十五条　电子商务经营者应当在其首页显著位置，持续公示营业执照信息、与其经营业务有关的行政许可信息、属于依照本法第十条规定的不需要办理市场主体登记情形等信息，或者上述信息的链接标识。</p><p>前款规定的信息发生变更的，电子商务经营者应当及时更新公示信息。</p><p>第十六条　电子商务经营者自行终止从事电子商务的，应当提前三十日在首页显著位置持续公示有关信息。</p><p>第十七条　电子商务经营者应当全面、真实、准确、及时地披露商品或者服务信息，保障消费者的知情权和选择权。电子商务经营者不得以虚构交易、编造用户评价等方式进行虚假或者引人误解的商业宣传，欺骗、误导消费者。</p><p>第十八条　电子商务经营者根据消费者的兴趣爱好、消费习惯等特征向其提供商品或者服务的搜索结果的，应当同时向该消费者提供不针对其个人特征的选项，尊重和平等保护消费者合法权益。</p><p>电子商务经营者向消费者发送广告的，应当遵守《中华人民共和国广告法》的有关规定。</p><p>第十九条　电子商务经营者搭售商品或者服务，应当以显著方式提请消费者注意，不得将搭售商品或者服务作为默认同意的选项。</p><p>第二十条　电子商务经营者应当按照承诺或者与消费者约定的方式、时限向消费者交付商品或者服务，并承担商品运输中的风险和责任。但是，消费者另行选择快递物流服务提供者的除外。</p><p>第二十一条　电子商务经营者按照约定向消费者收取押金的，应当明示押金退还的方式、程序，不得对押金退还设置不合理条件。消费者申请退还押金，符合押金退还条件的，电子商务经营者应当及时退还。</p><p>第二十二条　电子商务经营者因其技术优势、用户数量、对相关行业的控制能力以及其他经营者对该电子商务经营者在交易上的依赖程度等因素而具有市场支配地位的，不得滥用市场支配地位，排除、限制竞争。</p><p>第二十三条　电子商务经营者收集、使用其用户的个人信息，应当遵守法律、行政法规有关个人信息保护的规定。</p><p>第二十四条　电子商务经营者应当明示用户信息查询、更正、删除以及用户注销的方式、程序，不得对用户信息查询、更正、删除以及用户注销设置不合理条件。</p><p>电子商务经营者收到用户信息查询或者更正、删除的申请的，应当在核实身份后及时提供查询或者更正、删除用户信息。用户注销的，电子商务经营者应当立即删除该用户的信息；依照法律、行政法规的规定或者双方约定保存的，依照其规定。</p><p>第二十五条　有关主管部门依照法律、行政法规的规定要求电子商务经营者提供有关电子商务数据信息的，电子商务经营者应当提供。有关主管部门应当采取必要措施保护电子商务经营者提供的数据信息的安全，并对其中的个人信息、隐私和商业秘密严格保密，不得泄露、出售或者非法向他人提供。</p><p>第二十六条　电子商务经营者从事跨境电子商务，应当遵守进出口监督管理的法律、行政法规和国家有关规定。</p><h3>第二节　电子商务平台经营者。</h3><p>第二十七条　电子商务平台经营者应当要求申请进入平台销售商品或者提供服务的经营者提交其身份、地址、联系方式、行政许可等真实信息，进行核验、登记，建立登记档案，并定期核验更新。</p><p>电子商务平台经营者为进入平台销售商品或者提供服务的非经营用户提供服务，应当遵守本节有关规定。</p><p>第二十八条　电子商务平台经营者应当按照规定向市场监督管理部门报送平台内经营者的身份信息，提示未办理市场主体登记的经营者依法办理登记，并配合市场监督管理部门，针对电子商务的特点，为应当办理市场主体登记的经营者办理登记提供便利。</p><p>电子商务平台经营者应当依照税收征收管理法律、行政法规的规定，向税务部门报送平台内经营者的身份信息和与纳税有关的信息，并应当提示依照本法第十条规定不需要办理市场主体登记的电子商务经营者依照本法第十一条第二款的规定办理税务登记。</p><p>第二十九条　电子商务平台经营者发现平台内的商品或者服务信息存在违反本法第十二条、第十三条规定情形的，应当依法采取必要的处置措施，并向有关主管部门报告。</p><p>第三十条　电子商务平台经营者应当采取技术措施和其他必要措施保证其网络安全、稳定运行，防范网络违法犯罪活动，有效应对网络安全事件，保障电子商务交易安全。</p><p>电子商务平台经营者应当制定网络安全事件应急预案，发生网络安全事件时，应当立即启动应急预案，采取相应的补救措施，并向有关主管部门报告。</p><p>第三十一条　电子商务平台经营者应当记录、保存平台上发布的商品和服务信息、交易信息，并确保信息的完整性、保密性、可用性。商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。</p><p>第三十二条　电子商务平台经营者应当遵循公开、公平、公正的原则，制定平台服务协议和交易规则，明确进入和退出平台、商品和服务质量保障、消费者权益保护、个人信息保护等方面的权利和义务。</p><p>第三十三条　电子商务平台经营者应当在其首页显著位置持续公示平台服务协议和交易规则信息或者上述信息的链接标识，并保证经营者和消费者能够便利、完整地阅览和下载。</p><p>第三十四条　电子商务平台经营者修改平台服务协议和交易规则，应当在其首页显著位置公开征求意见，采取合理措施确保有关各方能够及时充分表达意见。修改内容应当至少在实施前七日予以公示。</p><p>平台内经营者不接受修改内容，要求退出平台的，电子商务平台经营者不得阻止，并按照修改前的服务协议和交易规则承担相关责任。</p><p>第三十五条　电子商务平台经营者不得利用服务协议、交易规则以及技术等手段，对平台内经营者在平台内的交易、交易价格以及与其他经营者的交易等进行不合理限制或者附加不合理条件，或者向平台内经营者收取不合理费用。</p><p>第三十六条　电子商务平台经营者依据平台服务协议和交易规则对平台内经营者违反法律、法规的行为实施警示、暂停或者终止服务等措施的，应当及时公示。</p><p>第三十七条　电子商务平台经营者在其平台上开展自营业务的，应当以显著方式区分标记自营业务和平台内经营者开展的业务，不得误导消费者。</p><p>电子商务平台经营者对其标记为自营的业务依法承担商品销售者或者服务提供者的民事责任。</p><p>第三十八条　电子商务平台经营者知道或者应当知道平台内经营者销售的商品或者提供的服务不符合保障人身、财产安全的要求，或者有其他侵害消费者合法权益行为，未采取必要措施的，依法与该平台内经营者承担连带责任。</p><p>对关系消费者生命健康的商品或者服务，电子商务平台经营者对平台内经营者的资质资格未尽到审核义务，或者对消费者未尽到安全保障义务，造成消费者损害的，依法承担相应的责任。</p><p>第三十九条　电子商务平台经营者应当建立健全信用评价制度，公示信用评价规则，为消费者提供对平台内销售的商品或者提供的服务进行评价的途径。</p><p>电子商务平台经营者不得删除消费者对其平台内销售的商品或者提供的服务的评价。</p><p>第四十条　电子商务平台经营者应当根据商品或者服务的价格、销量、信用等以多种方式向消费者显示商品或者服务的搜索结果；对于竞价排名的商品或者服务，应当显著标明“广告”。</p><p>第四十一条　电子商务平台经营者应当建立知识产权保护规则，与知识产权权利人加强合作，依法保护知识产权。</p><p>第四十二条　知识产权权利人认为其知识产权受到侵害的，有权通知电子商务平台经营者采取删除、屏蔽、断开链接、终止交易和服务等必要措施。通知应当包括构成侵权的初步证据。</p><p>电子商务平台经营者接到通知后，应当及时采取必要措施，并将该通知转送平台内经营者；未及时采取必要措施的，对损害的扩大部分与平台内经营者承担连带责任。</p><p>因通知错误造成平台内经营者损害的，依法承担民事责任。恶意发出错误通知，造成平台内经营者损失的，加倍承担赔偿责任。</p><p>第四十三条　平台内经营者接到转送的通知后，可以向电子商务平台经营者提交不存在侵权行为的声明。声明应当包括不存在侵权行为的初步证据。</p><p>电子商务平台经营者接到声明后，应当将该声明转送发出通知的知识产权权利人，并告知其可以向有关主管部门投诉或者向人民法院起诉。电子商务平台经营者在转送声明到达知识产权权利人后十五日内，未收到权利人已经投诉或者起诉通知的，应当及时终止所采取的措施。</p><p>第四十四条　电子商务平台经营者应当及时公示收到的本法第四十二条、第四十三条规定的通知、声明及处理结果。</p><p>第四十五条　电子商务平台经营者知道或者应当知道平台内经营者侵犯知识产权的，应当采取删除、屏蔽、断开链接、终止交易和服务等必要措施；未采取必要措施的，与侵权人承担连带责任。</p><p>第四十六条　除本法第九条第二款规定的服务外，电子商务平台经营者可以按照平台服务协议和交易规则，为经营者之间的电子商务提供仓储、物流、支付结算、交收等服务。电子商务平台经营者为经营者之间的电子商务提供服务，应当遵守法律、行政法规和国家有关规定，不得采取集中竞价、做市商等集中交易方式进行交易，不得进行标准化合约交易。</p><h2>第三章　电子商务合同的订立与履行</h2><p>第四十七条　电子商务当事人订立和履行合同，适用本章和《中华人民共和国民法总则》《中华人民共和国合同法》《中华人民共和国电子签名法》等法律的规定。</p><p>第四十八条　电子商务当事人使用自动信息系统订立或者履行合同的行为对使用该系统的当事人具有法律效力。</p><p>在电子商务中推定当事人具有相应的民事行为能力。但是，有相反证据足以推翻的除外。</p><p>第四十九条　电子商务经营者发布的商品或者服务信息符合要约条件的，用户选择该商品或者服务并提交订单成功，合同成立。当事人另有约定的，从其约定。</p><p>电子商务经营者不得以格式条款等方式约定消费者支付价款后合同不成立；格式条款等含有该内容的，其内容无效。</p><p>第五十条　电子商务经营者应当清晰、全面、明确地告知用户订立合同的步骤、注意事项、下载方法等事项，并保证用户能够便利、完整地阅览和下载。</p><p>电子商务经营者应当保证用户在提交订单前可以更正输入错误。</p><p>第五十一条　合同标的为交付商品并采用快递物流方式交付的，收货人签收时间为交付时间。合同标的为提供服务的，生成的电子凭证或者实物凭证中载明的时间为交付时间；前述凭证没有载明时间或者载明时间与实际提供服务时间不一致的，实际提供服务的时间为交付时间。</p><p>合同标的为采用在线传输方式交付的，合同标的进入对方当事人指定的特定系统并且能够检索识别的时间为交付时间。</p><p>合同当事人对交付方式、交付时间另有约定的，从其约定。</p><p>第五十二条　电子商务当事人可以约定采用快递物流方式交付商品。</p><p>快递物流服务提供者为电子商务提供快递物流服务，应当遵守法律、行政法规，并应当符合承诺的服务规范和时限。快递物流服务提供者在交付商品时，应当提示收货人当面查验；交由他人代收的，应当经收货人同意。</p><p>快递物流服务提供者应当按照规定使用环保包装材料，实现包装材料的减量化和再利用。</p><p>快递物流服务提供者在提供快递物流服务的同时，可以接受电子商务经营者的委托提供代收货款服务。</p><p>第五十三条　电子商务当事人可以约定采用电子支付方式支付价款。</p><p>电子支付服务提供者为电子商务提供电子支付服务，应当遵守国家规定，告知用户电子支付服务的功能、使用方法、注意事项、相关风险和收费标准等事项，不得附加不合理交易条件。电子支付服务提供者应当确保电子支付指令的完整性、一致性、可跟踪稽核和不可篡改。</p><p>电子支付服务提供者应当向用户免费提供对账服务以及最近三年的交易记录。</p><p>第五十四条　电子支付服务提供者提供电子支付服务不符合国家有关支付安全管理要求，造成用户损失的，应当承担赔偿责任。</p><p>第五十五条　用户在发出支付指令前，应当核对支付指令所包含的金额、收款人等完整信息。</p><p>支付指令发生错误的，电子支付服务提供者应当及时查找原因，并采取相关措施予以纠正。造成用户损失的，电子支付服务提供者应当承担赔偿责任，但能够证明支付错误非自身原因造成的除外。</p><p>第五十六条　电子支付服务提供者完成电子支付后，应当及时准确地向用户提供符合约定方式的确认支付的信息。</p><p>第五十七条　用户应当妥善保管交易密码、电子签名数据等安全工具。用户发现安全工具遗失、被盗用或者未经授权的支付的，应当及时通知电子支付服务提供者。</p><p>未经授权的支付造成的损失，由电子支付服务提供者承担；电子支付服务提供者能够证明未经授权的支付是因用户的过错造成的，不承担责任。</p><p>电子支付服务提供者发现支付指令未经授权，或者收到用户支付指令未经授权的通知时，应当立即采取措施防止损失扩大。电子支付服务提供者未及时采取措施导致损失扩大的，对损失扩大部分承担责任。</p><h2>第四章　电子商务争议解决</h2><p>第五十八条　国家鼓励电子商务平台经营者建立有利于电子商务发展和消费者权益保护的商品、服务质量担保机制。</p><p>电子商务平台经营者与平台内经营者协议设立消费者权益保证金的，双方应当就消费者权益保证金的提取数额、管理、使用和退还办法等作出明确约定。</p><p>消费者要求电子商务平台经营者承担先行赔偿责任以及电子商务平台经营者赔偿后向平台内经营者的追偿，适用《中华人民共和国消费者权益保护法》的有关规定。</p><p>第五十九条　电子商务经营者应当建立便捷、有效的投诉、举报机制，公开投诉、举报方式等信息，及时受理并处理投诉、举报。</p><p>第六十条　电子商务争议可以通过协商和解，请求消费者组织、行业协会或者其他依法成立的调解组织调解，向有关部门投诉，提请仲裁，或者提起诉讼等方式解决。</p><p>第六十一条　消费者在电子商务平台购买商品或者接受服务，与平台内经营者发生争议时，电子商务平台经营者应当积极协助消费者维护合法权益。</p><p>第六十二条　在电子商务争议处理中，电子商务经营者应当提供原始合同和交易记录。因电子商务经营者丢失、伪造、篡改、销毁、隐匿或者拒绝提供前述资料，致使人民法院、仲裁机构或者有关机关无法查明事实的，电子商务经营者应当承担相应的法律责任。</p><p>第六十三条　电子商务平台经营者可以建立争议在线解决机制，制定并公示争议解决规则，根据自愿原则，公平、公正地解决当事人的争议。</p><h2>第五章　电子商务促进</h2><p>第六十四条　国务院和省、自治区、直辖市人民政府应当将电子商务发展纳入国民经济和社会发展规划，制定科学合理的产业政策，促进电子商务创新发展。</p><p>第六十五条　国务院和县级以上地方人民政府及其有关部门应当采取措施，支持、推动绿色包装、仓储、运输，促进电子商务绿色发展。</p><p>第六十六条　国家推动电子商务基础设施和物流网络建设，完善电子商务统计制度，加强电子商务标准体系建设。</p><p>第六十七条　国家推动电子商务在国民经济各个领域的应用，支持电子商务与各产业融合发展。</p><p>第六十八条　国家促进农业生产、加工、流通等环节的互联网技术应用，鼓励各类社会资源加强合作，促进农村电子商务发展，发挥电子商务在精准扶贫中的作用。</p><p>第六十九条　国家维护电子商务交易安全，保护电子商务用户信息，鼓励电子商务数据开发应用，保障电子商务数据依法有序自由流动。</p><p>国家采取措施推动建立公共数据共享机制，促进电子商务经营者依法利用公共数据。</p><p>第七十条　国家支持依法设立的信用评价机构开展电子商务信用评价，向社会提供电子商务信用评价服务。</p><p>第七十一条　国家促进跨境电子商务发展，建立健全适应跨境电子商务特点的海关、税收、进出境检验检疫、支付结算等管理制度，提高跨境电子商务各环节便利化水平，支持跨境电子商务平台经营者等为跨境电子商务提供仓储物流、报关、报检等服务。</p><p>国家支持小型微型企业从事跨境电子商务。</p><p>第七十二条　国家进出口管理部门应当推进跨境电子商务海关申报、纳税、检验检疫等环节的综合服务和监管体系建设，优化监管流程，推动实现信息共享、监管互认、执法互助，提高跨境电子商务服务和监管效率。跨境电子商务经营者可以凭电子单证向国家进出口管理部门办理有关手续。</p><p>第七十三条　国家推动建立与不同国家、地区之间跨境电子商务的交流合作，参与电子商务国际规则的制定，促进电子签名、电子身份等国际互认。</p><p>国家推动建立与不同国家、地区之间的跨境电子商务争议解决机制。</p><h2>第六章　法律责任</h2><p>第七十四条　电子商务经营者销售商品或者提供服务，不履行合同义务或者履行合同义务不符合约定，或者造成他人损害的，依法承担民事责任。</p><p>第七十五条　电子商务经营者违反本法第十二条、第十三条规定，未取得相关行政许可从事经营活动，或者销售、提供法律、行政法规禁止交易的商品、服务，或者不履行本法第二十五条规定的信息提供义务，电子商务平台经营者违反本法第四十六条规定，采取集中交易方式进行交易，或者进行标准化合约交易的，依照有关法律、行政法规的规定处罚。</p><p>第七十六条　电子商务经营者违反本法规定，有下列行为之一的，由市场监督管理部门责令限期改正，可以处一万元以下的罚款，对其中的电子商务平台经营者，依照本法第八十一条第一款的规定处罚：</p><p>（一）未在首页显著位置公示营业执照信息、行政许可信息、属于不需要办理市场主体登记情形等信息，或者上述信息的链接标识的；</p><p>（二）未在首页显著位置持续公示终止电子商务的有关信息的；</p><p>（三）未明示用户信息查询、更正、删除以及用户注销的方式、程序，或者对用户信息查询、更正、删除以及用户注销设置不合理条件的。</p><p>电子商务平台经营者对违反前款规定的平台内经营者未采取必要措施的，由市场监督管理部门责令限期改正，可以处二万元以上十万元以下的罚款。</p><p>第七十七条　电子商务经营者违反本法第十八条第一款规定提供搜索结果，或者违反本法第十九条规定搭售商品、服务的，由市场监督管理部门责令限期改正，没收违法所得，可以并处五万元以上二十万元以下的罚款；情节严重的，并处二十万元以上五十万元以下的罚款。</p><p>第七十八条　电子商务经营者违反本法第二十一条规定，未向消费者明示押金退还的方式、程序，对押金退还设置不合理条件，或者不及时退还押金的，由有关主管部门责令限期改正，可以处五万元以上二十万元以下的罚款；情节严重的，处二十万元以上五十万元以下的罚款。</p><p>第七十九条　电子商务经营者违反法律、行政法规有关个人信息保护的规定，或者不履行本法第三十条和有关法律、行政法规规定的网络安全保障义务的，依照《中华人民共和国网络安全法》等法律、行政法规的规定处罚。</p><p>第八十条　电子商务平台经营者有下列行为之一的，由有关主管部门责令限期改正；逾期不改正的，处二万元以上十万元以下的罚款；情节严重的，责令停业整顿，并处十万元以上五十万元以下的罚款：</p><p>（一）不履行本法第二十七条规定的核验、登记义务的；</p><p>（二）不按照本法第二十八条规定向市场监督管理部门、税务部门报送有关信息的；</p><p>（三）不按照本法第二十九条规定对违法情形采取必要的处置措施，或者未向有关主管部门报告的；</p><p>（四）不履行本法第三十一条规定的商品和服务信息、交易信息保存义务的。</p><p>法律、行政法规对前款规定的违法行为的处罚另有规定的，依照其规定。</p><p>第八十一条　电子商务平台经营者违反本法规定，有下列行为之一的，由市场监督管理部门责令限期改正，可以处二万元以上十万元以下的罚款；情节严重的，处十万元以上五十万元以下的罚款：</p><p>（一）未在首页显著位置持续公示平台服务协议、交易规则信息或者上述信息的链接标识的；</p><p>（二）修改交易规则未在首页显著位置公开征求意见，未按照规定的时间提前公示修改内容，或者阻止平台内经营者退出的；</p><p>（三）未以显著方式区分标记自营业务和平台内经营者开展的业务的；</p><p>（四）未为消费者提供对平台内销售的商品或者提供的服务进行评价的途径，或者擅自删除消费者的评价的。</p><p>电子商务平台经营者违反本法第四十条规定，对竞价排名的商品或者服务未显著标明“广告”的，依照《中华人民共和国广告法》的规定处罚。</p><p>第八十二条　电子商务平台经营者违反本法第三十五条规定，对平台内经营者在平台内的交易、交易价格或者与其他经营者的交易等进行不合理限制或者附加不合理条件，或者向平台内经营者收取不合理费用的，由市场监督管理部门责令限期改正，可以处五万元以上五十万元以下的罚款；情节严重的，处五十万元以上二百万元以下的罚款。</p><p>第八十三条　电子商务平台经营者违反本法第三十八条规定，对平台内经营者侵害消费者合法权益行为未采取必要措施，或者对平台内经营者未尽到资质资格审核义务，或者对消费者未尽到安全保障义务的，由市场监督管理部门责令限期改正，可以处五万元以上五十万元以下的罚款；情节严重的，责令停业整顿，并处五十万元以上二百万元以下的罚款。</p><p>第八十四条　电子商务平台经营者违反本法第四十二条、第四十五条规定，对平台内经营者实施侵犯知识产权行为未依法采取必要措施的，由有关知识产权行政部门责令限期改正；逾期不改正的，处五万元以上五十万元以下的罚款；情节严重的，处五十万元以上二百万元以下的罚款。</p><p>第八十五条　电子商务经营者违反本法规定，销售的商品或者提供的服务不符合保障人身、财产安全的要求，实施虚假或者引人误解的商业宣传等不正当竞争行为，滥用市场支配地位，或者实施侵犯知识产权、侵害消费者权益等行为的，依照有关法律的规定处罚。</p><p>第八十六条　电子商务经营者有本法规定的违法行为的，依照有关法律、行政法规的规定记入信用档案，并予以公示。</p><p>第八十七条　依法负有电子商务监督管理职责的部门的工作人员，玩忽职守、滥用职权、徇私舞弊，或者泄露、出售或者非法向他人提供在履行职责中所知悉的个人信息、隐私和商业秘密的，依法追究法律责任。</p><p>第八十八条　违反本法规定，构成违反治安管理行为的，依法给予治安管理处罚；构成犯罪的，依法追究刑事责任。</p><h2>第七章　附则</h2><p>第八十九条　本法自2019年1月1日起施行。</p><br/><p>法律原文链接http://www.mofcom.gov.cn/article/zt_dzswf/deptReport/201811/20181102808398.shtml</p>'
				},
				pact1: {
					title: '网络交易监督管理办法',
					entry_time: '2021年5月1日',
					version_time: '2022年6月9日',
					content: '<h2>（2021年3月15日国家市场监督管理总局令第37号公布）</h2><br/><h2>第一章 总 则</h2><p>第一条 为了规范网络交易活动，维护网络交易秩序，保障网络交易各方主体合法权益，促进数字经济持续健康发展，根据有关法律、行政法规，制定本办法。</p><p>第二条 在中华人民共和国境内，通过互联网等信息网络（以下简称通过网络）销售商品或者提供服务的经营活动以及市场监督管理部门对其进行监督管理，适用本办法。</p><p>在网络社交、网络直播等信息网络活动中销售商品或者提供服务的经营活动，适用本办法。</p><p>第三条 网络交易经营者从事经营活动，应当遵循自愿、平等、公平、诚信原则，遵守法律、法规、规章和商业道德、公序良俗，公平参与市场竞争，认真履行法定义务，积极承担主体责任，接受社会各界监督。</p><p>第四条 网络交易监督管理坚持鼓励创新、包容审慎、严守底线、线上线下一体化监管的原则。</p><p>第五条 国家市场监督管理总局负责组织指导全国网络交易监督管理工作。</p><p>县级以上地方市场监督管理部门负责本行政区域内的网络交易监督管理工作。</p><p>第六条 市场监督管理部门引导网络交易经营者、网络交易行业组织、消费者组织、消费者共同参与网络交易市场治理，推动完善多元参与、有效协同、规范有序的网络交易市场治理体系。</p><h2>第二章 网络交易经营者</h2><p>第一节 一般规定</p><p>第七条 本办法所称网络交易经营者，是指组织、开展网络交易活动的自然人、法人和非法人组织，包括网络交易平台经营者、平台内经营者、自建网站经营者以及通过其他网络服务开展网络交易活动的网络交易经营者。</p><p>本办法所称网络交易平台经营者，是指在网络交易活动中为交易双方或者多方提供网络经营场所、交易撮合、信息发布等服务，供交易双方或者多方独立开展网络交易活动的法人或者非法人组织。</p><p>本办法所称平台内经营者，是指通过网络交易平台开展网络交易活动的网络交易经营者。</p><p>网络社交、网络直播等网络服务提供者为经营者提供网络经营场所、商品浏览、订单生成、在线支付等网络交易平台服务的，应当依法履行网络交易平台经营者的义务。通过上述网络交易平台服务开展网络交易活动的经营者，应当依法履行平台内经营者的义务。</p><p>第八条 网络交易经营者不得违反法律、法规、国务院决定的规定，从事无证无照经营。除《中华人民共和国电子商务法》第十条规定的不需要进行登记的情形外，网络交易经营者应当依法办理市场主体登记。</p><p>个人通过网络从事保洁、洗涤、缝纫、理发、搬家、配制钥匙、管道疏通、家电家具修理修配等依法无须取得许可的便民劳务活动，依照《中华人民共和国电子商务法》第十条的规定不需要进行登记。</p><p>个人从事网络交易活动，年交易额累计不超过10万元的，依照《中华人民共和国电子商务法》第十条的规定不需要进行登记。同一经营者在同一平台或者不同平台开设多家网店的，各网店交易额合并计算。个人从事的零星小额交易须依法取得行政许可的，应当依法办理市场主体登记。</p><p>第九条 仅通过网络开展经营活动的平台内经营者申请登记为个体工商户的，可以将网络经营场所登记为经营场所，将经常居住地登记为住所，其住所所在地的县、自治县、不设区的市、市辖区市场监督管理部门为其登记机关。同一经营者有两个以上网络经营场所的，应当一并登记。</p><p>第十条 平台内经营者申请将网络经营场所登记为经营场所的，由其入驻的网络交易平台为其出具符合登记机关要求的网络经营场所相关材料。</p><p>第十一条 网络交易经营者销售的商品或者提供的服务应当符合保障人身、财产安全的要求和环境保护要求，不得销售或者提供法律、行政法规禁止交易，损害国家利益和社会公共利益，违背公序良俗的商品或者服务。</p><p>第十二条 网络交易经营者应当在其网站首页或者从事经营活动的主页面显著位置，持续公示经营者主体信息或者该信息的链接标识。鼓励网络交易经营者链接到国家市场监督管理总局电子营业执照亮照系统，公示其营业执照信息。</p><p>已经办理市场主体登记的网络交易经营者应当如实公示下列营业执照信息以及与其经营业务有关的行政许可等信息，或者该信息的链接标识：</p><p>（一）企业应当公示其营业执照登载的统一社会信用代码、名称、企业类型、法定代表人（负责人）、住所、注册资本（出资额）等信息；</p><p>（二）个体工商户应当公示其营业执照登载的统一社会信用代码、名称、经营者姓名、经营场所、组成形式等信息；</p><p>（三）农民专业合作社、农民专业合作社联合社应当公示其营业执照登载的统一社会信用代码、名称、法定代表人、住所、成员出资总额等信息。</p><p>依照《中华人民共和国电子商务法》第十条规定不需要进行登记的经营者应当根据自身实际经营活动类型，如实公示以下自我声明以及实际经营地址、联系方式等信息，或者该信息的链接标识：</p><p>（一）“个人销售自产农副产品，依法不需要办理市场主体登记”；</p><p>（二）“个人销售家庭手工业产品，依法不需要办理市场主体登记”；</p><p>（三）“个人利用自己的技能从事依法无须取得许可的便民劳务活动，依法不需要办理市场主体登记”；</p><p>（四）“个人从事零星小额交易活动，依法不需要办理市场主体登记”。</p><p>网络交易经营者公示的信息发生变更的，应当在十个工作日内完成更新公示。</p><p>第十三条 网络交易经营者收集、使用消费者个人信息，应当遵循合法、正当、必要的原则，明示收集、使用信息的目的、方式和范围，并经消费者同意。网络交易经营者收集、使用消费者个人信息，应当公开其收集、使用规<p></p>则，不得违反法律、法规的规定和双方的约定收集、使用信息。</p><p>网络交易经营者不得采用一次概括授权、默认授权、与其他授权捆绑、停止安装使用等方式，强迫或者变相强迫消费者同意收集、使用与经营活动无直接关系的信息。收集、使用个人生物特征、医疗健康、金融账户、个人行踪等敏感信息的，应当逐项取得消费者同意。</p><p>网络交易经营者及其工作人员应当对收集的个人信息严格保密，除依法配合监管执法活动外，未经被收集者授权同意，不得向包括关联方在内的任何第三方提供。</p><p>第十四条 网络交易经营者不得违反《中华人民共和国反不正当竞争法》等规定，实施扰乱市场竞争秩序，损害其他经营者或者消费者合法权益的不正当竞争行为。</p><p>网络交易经营者不得以下列方式，作虚假或者引人误解的商业宣传，欺骗、误导消费者：</p><p>（一）虚构交易、编造用户评价；</p><p>（二）采用误导性展示等方式，将好评前置、差评后置，或者不显著区分不同商品或者服务的评价等；</p><p>（三）采用谎称现货、虚构预订、虚假抢购等方式进行虚假营销；</p><p>（四）虚构点击量、关注度等流量数据，以及虚构点赞、打赏等交易互动数据。</p><p>网络交易经营者不得实施混淆行为，引人误认为是他人商品、服务或者与他人存在特定联系。</p><p>网络交易经营者不得编造、传播虚假信息或者误导性信息，损害竞争对手的商业信誉、商品声誉。</p><p>第十五条 消费者评价中包含法律、行政法规、规章禁止发布或者传输的信息的，网络交易经营者可以依法予以技术处理。</p><p>第十六条 网络交易经营者未经消费者同意或者请求，不得向其发送商业性信息。</p><p>网络交易经营者发送商业性信息时，应当明示其真实身份和联系方式，并向消费者提供显著、简便、免费的拒绝继续接收的方式。消费者明确表示拒绝的，应当立即停止发送，不得更换名义后再次发送。</p><p>第十七条 网络交易经营者以直接捆绑或者提供多种可选项方式向消费者搭售商品或者服务的，应当以显著方式提醒消费者注意。提供多种可选项方式的，不得将搭售商品或者服务的任何选项设定为消费者默认同意，不得将消费者以往交易中选择的选项在后续独立交易中设定为消费者默认选择。</p><p>第十八条 网络交易经营者采取自动展期、自动续费等方式提供服务的，应当在消费者接受服务前和自动展期、自动续费等日期前五日，以显著方式提请消费者注意，由消费者自主选择；在服务期间内，应当为消费者提供显著、简便的随时取消或者变更的选项，并不得收取不合理费用。</p><p>第十九条 网络交易经营者应当全面、真实、准确、及时地披露商品或者服务信息，保障消费者的知情权和选择权。</p><p>第二十条 通过网络社交、网络直播等网络服务开展网络交易活动的网络交易经营者，应当以显著方式展示商品或者服务及其实际经营主体、售后服务等信息，或者上述信息的链接标识。</p><p>网络直播服务提供者对网络交易活动的直播视频保存时间自直播结束之日起不少于三年。</p><p>第二十一条 网络交易经营者向消费者提供商品或者服务使用格式条款、通知、声明等的，应当以显著方式提请消费者注意与消费者有重大利害关系的内容，并按照消费者的要求予以说明，不得作出含有下列内容的规定：</p><p>（一）免除或者部分免除网络交易经营者对其所提供的商品或者服务应当承担的修理、重作、更换、退货、补足商品数量、退还货款和服务费用、赔偿损失等责任；</p><p>（二）排除或者限制消费者提出修理、更换、退货、赔偿损失以及获得违约金和其他合理赔偿的权利；</p><p>（三）排除或者限制消费者依法投诉、举报、请求调解、申请仲裁、提起诉讼的权利；</p><p>（四）排除或者限制消费者依法变更或者解除合同的权利；</p><p>（五）规定网络交易经营者单方享有解释权或者最终解释权；</p><p>（六）其他对消费者不公平、不合理的规定。</p><p>第二十二条 网络交易经营者应当按照国家市场监督管理总局及其授权的省级市场监督管理部门的要求，提供特定时段、特定品类、特定区域的商品或者服务的价格、销量、销售额等数据信息。</p><p>第二十三条 网络交易经营者自行终止从事网络交易活动的，应当提前三十日在其网站首页或者从事经营活动的主页面显著位置，持续公示终止网络交易活动公告等有关信息，并采取合理、必要、及时的措施保障消费者和相关经营者的合法权益。</p><p>第二节 网络交易平台经营者</p><p>第二十四条 网络交易平台经营者应当要求申请进入平台销售商品或者提供服务的经营者提交其身份、地址、联系方式、行政许可等真实信息，进行核验、登记，建立登记档案，并至少每六个月核验更新一次。</p><p>网络交易平台经营者应当对未办理市场主体登记的平台内经营者进行动态监测，对超过本办法第八条第三款规定额度的，及时提醒其依法办理市场主体登记。</p><p>第二十五条 网络交易平台经营者应当依照法律、行政法规的规定，向市场监督管理部门报送有关信息。</p><p>网络交易平台经营者应当分别于每年1月和7月向住所地省级市场监督管理部门报送平台内经营者的下列身份信息：</p><p>（一）已办理市场主体登记的平台内经营者的名称（姓名）、统一社会信用代码、实际经营地址、联系方式、网店名称以及网址链接等信息；</p><p>（二）未办理市场主体登记的平台内经营者的姓名、身份证件号码、实际经营地址、联系方式、网店名称以及网址链接、属于依法不需要办理市场主体登记的具体情形的自我声明等信息；其中，对超过本办法第八条第三款规定额度的平台内经营者进行特别标示。</p><p>鼓励网络交易平台经营者与市场监督管理部门建立开放数据接口等形式的自动化信息报送机制。</p><p>第二十六条 网络交易平台经营者应当为平台内经营者依法履行信息公示义务提供技术支持。平台内经营者公示的信息发生变更的，应当在三个工作日内将变更情况报送平台，平台应当在七个工作日内进行核验，完成更新公示。</p><p>第二十七条 网络交易平台经营者应当以显著方式区分标记已办理市场主体登记的经营者和未办理市场主体登记的经营者，确保消费者能够清晰辨认。</p><p>第二十八条 网络交易平台经营者修改平台服务协议和交易规则的，应当完整保存修改后的版本生效之日前三年的全部历史版本，并保证经营者和消费者能够便利、完整地阅览和下载。</p><p>第二十九条 网络交易平台经营者应当对平台内经营者及其发布的商品或者服务信息建立检查监控制度。网络交易平台经营者发现平台内的商品或者服务信息有违反市场监督管理法律、法规、规章，损害国家利益和社会公共利益，违背公序良俗的，应当依法采取必要的处置措施，保存有关记录，并向平台住所地县级以上市场监督管理部门报告。</p><p>第三十条 网络交易平台经营者依据法律、法规、规章的规定或者平台服务协议和交易规则对平台内经营者违法行为采取警示、暂停或者终止服务等处理措施的，应当自决定作出处理措施之日起一个工作日内予以公示，载明平台内经营者的网店名称、违法行为、处理措施等信息。警示、暂停服务等短期处理措施的相关信息应当持续公示至处理措施实施期满之日止。</p><p>第三十一条 网络交易平台经营者对平台内经营者身份信息的保存时间自其退出平台之日起不少于三年；对商品或者服务信息，支付记录、物流快递、退换货以及售后等交易信息的保存时间自交易完成之日起不少于三年。法律、行政法规另有规定的，依照其规定。</p><p>第三十二条 网络交易平台经营者不得违反《中华人民共和国电子商务法》第三十五条的规定，对平台内经营者在平台内的交易、交易价格以及与其他经营者的交易等进行不合理限制或者附加不合理条件，干涉平台内经营者的自主经营。具体包括：</p><p>（一）通过搜索降权、下架商品、限制经营、屏蔽店铺、提高服务收费等方式，禁止或者限制平台内经营者自主选择在多个平台开展经营活动，或者利用不正当手段限制其仅在特定平台开展经营活动；</p><p>（二）禁止或者限制平台内经营者自主选择快递物流等交易辅助服务提供者；</p><p>（三）其他干涉平台内经营者自主经营的行为。</p><h2>第三章 监督管理</h2><p>第三十三条 县级以上地方市场监督管理部门应当在日常管理和执法活动中加强协同配合。</p><p>网络交易平台经营者住所地省级市场监督管理部门应当根据工作需要，及时将掌握的平台内经营者身份信息与其实际经营地的省级市场监督管理部门共享。</p><p>第三十四条 市场监督管理部门在依法开展监督检查、案件调查、事故处置、缺陷消费品召回、消费争议处理等监管执法活动时，可以要求网络交易平台经营者提供有关的平台内经营者身份信息，商品或者服务信息，支付记录、物流快递、退换货以及售后等交易信息。网络交易平台经营者应当提供，并在技术方面积极配合市场监督管理部门开展网络交易违法行为监测工作。</p><p>为网络交易经营者提供宣传推广、支付结算、物流快递、网络接入、服务器托管、虚拟主机、云服务、网站网页设计制作等服务的经营者（以下简称其他服务提供者），应当及时协助市场监督管理部门依法查处网络交易违法行为，提供其掌握的有关数据信息。法律、行政法规另有规定的，依照其规定。</p><p>市场监督管理部门发现网络交易经营者有违法行为，依法要求网络交易平台经营者、其他服务提供者采取措施制止的，网络交易平台经营者、其他服务提供者应当予以配合。</p><p>第三十五条 市场监督管理部门对涉嫌违法的网络交易行为进行查处时，可以依法采取下列措施：</p><p>（一）对与涉嫌违法的网络交易行为有关的场所进行现场检查；</p><p>（二）查阅、复制与涉嫌违法的网络交易行为有关的合同、票据、账簿等有关资料；</p><p>（三）收集、调取、复制与涉嫌违法的网络交易行为有关的电子数据；</p><p>（四）询问涉嫌从事违法的网络交易行为的当事人；</p><p>（五）向与涉嫌违法的网络交易行为有关的自然人、法人和非法人组织调查了解有关情况；</p><p>（六）法律、法规规定可以采取的其他措施。</p><p>采取前款规定的措施，依法需要报经批准的，应当办理批准手续。</p><p>市场监督管理部门对网络交易违法行为的技术监测记录资料，可以作为实施行政处罚或者采取行政措施的电子数据证据。</p><p>第三十六条 市场监督管理部门应当采取必要措施保护网络交易经营者提供的数据信息的安全，并对其中的个人信息、隐私和商业秘密严格保密。</p><p>第三十七条 市场监督管理部门依法对网络交易经营者实施信用监管，将网络交易经营者的注册登记、备案、行政许可、抽查检查结果、行政处罚、列入经营异常名录和严重违法失信企业名单等信息，通过国家企业信用信息公示系统统一归集并公示。对存在严重违法失信行为的，依法实施联合惩戒。</p><p>前款规定的信息还可以通过市场监督管理部门官方网站、网络搜索引擎、经营者从事经营活动的主页面显著位置等途径公示。</p><p>第三十八条 网络交易经营者未依法履行法定责任和义务，扰乱或者可能扰乱网络交易秩序，影响消费者合法权益的，市场监督管理部门可以依职责对其法定代表人或者主要负责人进行约谈，要求其采取措施进行整改。</p><h2>第四章 法律责任</h2><p>第三十九条 法律、行政法规对网络交易违法行为的处罚已有规定的，依照其规定。</p><p>第四十条 网络交易平台经营者违反本办法第十条，拒不为入驻的平台内经营者出具网络经营场所相关材料的，由市场监督管理部门责令限期改正；逾期不改正的，处一万元以上三万元以下罚款。</p><p>第四十一条 网络交易经营者违反本办法第十一条、第十三条、第十六条、第十八条，法律、行政法规有规定的，依照其规定；法律、行政法规没有规定的，由市场监督管理部门依职责责令限期改正，可以处五千元以上三万元以下罚款。</p><p>第四十二条 网络交易经营者违反本办法第十二条、第二十三条，未履行法定信息公示义务的，依照《中华人民共和国电子商务法》第七十六条的规定进行处罚。对其中的网络交易平台经营者，依照《中华人民共和国电子商务法》第八十一条第一款的规定进行处罚。</p><p>第四十三条 网络交易经营者违反本办法第十四条的，依照《中华人民共和国反不正当竞争法》的相关规定进行处罚。</p><p>第四十四条 网络交易经营者违反本办法第十七条的，依照《中华人民共和国电子商务法》第七十七条的规定进行处罚。</p><p>第四十五条 网络交易经营者违反本办法第二十条，法律、行政法规有规定的，依照其规定；法律、行政法规没有规定的，由市场监督管理部门责令限期改正；逾期不改正的，处一万元以下罚款。</p><p>第四十六条 网络交易经营者违反本办法第二十二条的，由市场监督管理部门责令限期改正；逾期不改正的，处五千元以上三万元以下罚款。</p><p>第四十七条 网络交易平台经营者违反本办法第二十四条第一款、第二十五条第二款、第三十一条，不履行法定核验、登记义务，有关信息报送义务，商品和服务信息、交易信息保存义务的，依照《中华人民共和国电子商务法》第八十条的规定进行处罚。</p><p>第四十八条 网络交易平台经营者违反本办法第二十七条、第二十八条、第三十条的，由市场监督管理部门责令限期改正；逾期不改正的，处一万元以上三万元以下罚款。</p><p>第四十九条 网络交易平台经营者违反本办法第二十九条，法律、行政法规有规定的，依照其规定；法律、行政法规没有规定的，由市场监督管理部门依职责责令限期改正，可以处一万元以上三万元以下罚款。</p><p>第五十条 网络交易平台经营者违反本办法第三十二条的，依照《中华人民共和国电子商务法》第八十二条的规定进行处罚。</p><p>第五十一条 网络交易经营者销售商品或者提供服务，不履行合同义务或者履行合同义务不符合约定，或者造成他人损害的，依法承担民事责任。</p><p>第五十二条 网络交易平台经营者知道或者应当知道平台内经营者销售的商品或者提供的服务不符合保障人身、财产安全的要求，或者有其他侵害消费者合法权益行为，未采取必要措施的，依法与该平台内经营者承担连带责任。</p><p>对关系消费者生命健康的商品或者服务，网络交易平台经营者对平台内经营者的资质资格未尽到审核义务，或者对消费者未尽到安全保障义务，造成消费者损害的，依法承担相应的责任。</p><p>第五十三条 对市场监督管理部门依法开展的监管执法活动，拒绝依照本办法规定提供有关材料、信息，或者提供虚假材料、信息，或者隐匿、销毁、转移证据，或者有其他拒绝、阻碍监管执法行为，法律、行政法规、其他市场监督管理部门规章有规定的，依照其规定；法律、行政法规、其他市场监督管理部门规章没有规定的，由市场监督管理部门责令改正，可以处五千元以上三万元以下罚款。</p><p>第五十四条市场监督管理部门的工作人员，玩忽职守、滥用职权、徇私舞弊，或者泄露、出售或者非法向他人提供在履行职责中所知悉的个人信息、隐私和商业秘密的，依法追究法律责任。</p><p>第五十五条 违反本办法规定，构成犯罪的，依法追究刑事责任。</p><h2>第五章 附 则</h2><p>第五十六条 本办法自2021年5月1日起施行。2014年1月26日原国家工商行政管理总局令第60号公布的《网络交易管理办法》同时废止。</p>'
				}
			}
		},
		components: {
			detailNav,
			previewImgs,
			quillEditor
		},
		created() {
			this.getInfo();
		},
		mounted() {
			
		},
		methods: {
			previewPact(index) {
				this['showPact' + index] = true;
			},
			close() {
				this.showPact0 = false;
				this.showPact1 = false;
			},
			checkOrder(){
				var that = this;
				getOrder({order_sn:this.order_sn}).then(res=>{
					if(res.data==1){
						clearInterval(timekey);
						this.$message.success('申请类目成功');
						this.is_success = true;
						setTimeout(function(){
							that.showPreviewDialog = false;
							that.$router.go(-1);
						},3000);
					}
				})
			},
			
			open_qual_img(index,index_){
				var imgs = this.quals[index].quals[index_].imgs;
				var showQualImgs = [];
				for(var i=0;i<imgs.length;i++){
					showQualImgs[i] = imgs[i]['file_path'];
				}
				this.showQualImgs = showQualImgs;
				this.showQualExpImg = true;
			},
			/* 组件回调 */
			closePreview() {
				this.showQualExpImg = false;
			},
			changeImgsIndex(res) {
				this.qualImgIndex = res.index;
			},
			onCopySuccess(res) {
				this.$message.success("内容已复制到剪切板");
			},
			onCopyError() {
				this.$message.error("复制失败");
			},
			closePreviewDialog(done) {
				done();
				this.showPreviewDialog = false;
				this.previewImageUrl = '';
				this.type = 'offline';
				clearInterval(timekey);
				this.btndis = false;
			},
			handleClick(tab, event){
				if(this.type=='wxpay'){
					var that = this;
					if(this.previewImageUrl){
						timekey = setInterval(function(){
							that.checkOrder();
						},1000);
					}else{
						// let loadingInstance1 = this.$loading.service({ fullscreen: true });
						let loadingInstance1 = this.$loading({
						  lock: true,
						  text: 'Loading',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
						cateApply({
							type:'wxpay',
							quals:JSON.stringify(this.quals),
							cate_id:this.cate_fir[this.fir_index].id,
							cate_name:this.cate_fir[this.fir_index].name,
							root_id:this.cate_big[this.big_index].id,
							root_name:this.cate_big[this.big_index].name,
						}).then(res=>{
							this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
							  loadingInstance1.close();
							});
							if(res.code==0){
								this.previewImageUrl = res.data.code_url;
								this.order_sn = res.data.order_sn;
								timekey = setInterval(function(){
									that.checkOrder();
								},1000);
							}else{
								this.$message.error(res.message);
							}
						})
					}
				}else{
					clearInterval(timekey);
				}
			},
			offlinePay(){
				if(this.btndis){
					return false;
				}
				this.btndis = true;
				if (this.type == 'offline') {
					if (this.myForm.accountName == '') {
						this.$message.error("请填写付款户名");
						this.btndis = false;
						return false;
					}
					if (this.myForm.account == '') {
						this.$message.error("请填写付款帐号");
						this.btndis = false;
						return false;
					}
					if (this.myForm.accountDate == '') {
						this.$message.error("请选择付款日期");
						this.btndis = false;
						return false;
					}
					// let loadingInstance3 = this.$loading.service({ fullscreen: true });
					let loadingInstance3 = this.$loading({
					  lock: true,
					  text: 'Loading',
					  spinner: 'el-icon-loading',
					  background: 'rgba(0, 0, 0, 0.7)'
					});
					cateApply({
						type:'offline',
						quals:JSON.stringify(this.quals),
						cate_id:this.cate_fir[this.fir_index].id,
						cate_name:this.cate_fir[this.fir_index].name,
						root_id:this.cate_big[this.big_index].id,
						root_name:this.cate_big[this.big_index].name,
						account: this.myForm.account,
						account_name: this.myForm.accountName,
						account_date: String(this.myForm.accountDate.getTime()).substr(0, 10)
					}).then(res=>{
						this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
						  loadingInstance3.close();
						});
						if(res.code==0){
							this.$message.success('提交申请成功，等待财务审核中');
							var that = this;
							setTimeout(function(){
								that.$router.go(-1);
							},2500)
						}else if(res.code=='40001'){
							this.$message.error(res.message);
							this.btndis = false;
						}else{
							this.btndis = false;
						}
					})
				}
			},
			apply(){
				if(this.btndis){
					return false;
				}
				this.btndis = true;
				if(!this.agree_protocol){
					this.$message.error('请阅读并承诺保证所经营的类型符合《电子商务法》以及《网络交易监督管理办法》的相关规定');
					this.btndis = false;
					return false;
				}
				var that = this;
				var quals = this.quals;
				if(quals.length>1){
					for(var i=0;i<quals.length;i++){
						if(quals[i].is_need==1){
							for(var j=0;j<quals[i].quals.length;j++){
								if(quals[i].quals[j].imgid==0){
									this.$message.error("请上传"+quals[i].quals[j].name+"资质图片");
									this.btndis = false;
									return false;
								}
							}
						}
					}
				}
				// if(this.pay_money==0){
					let loadingInstance2 = this.$loading({
					  lock: true,
					  text: 'Loading',
					  spinner: 'el-icon-loading',
					  background: 'rgba(0, 0, 0, 0.7)'
					});
					cateApplyFree({
						type:'free',
						quals:JSON.stringify(this.quals),
						cate_id:this.cate_fir[this.fir_index].id,
						cate_name:this.cate_fir[this.fir_index].name,
						root_id:this.cate_big[this.big_index].id,
						root_name:this.cate_big[this.big_index].name,
					}).then(res=>{
						this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
						  loadingInstance2.close();
						});
						if(res.code==0){
							this.$message.success('申请成功');
							setTimeout(function(){
								that.$router.go(-1);
							},2500)
						}else if(res.code=='40001'){
							this.$message.error(res.message);
							this.btndis = false;
						}else{
							this.btndis = false;
						}
					})
				// }else{
				// 	this.btndis = false;
				// 	this.showPreviewDialog = true;
				// }
			},
			gpNavigateback() {
				this.$router.go(-1)
			},
			changebig(index){
				if(this.big_index == index){
					return false;
				}
				this.big_index = index;
				this.cate_fir = this.cate_big[index].categories;
				this.fir_index = 0;
				this.getcate();
			},
			changefir(index){
				if(this.fir_index == index){
					return false;
				}
				this.fir_index = index;
				this.getcate();
			},
			getcate(){
				var cate_id = this.cate_fir[this.fir_index].id;
				getCateInfo({cate_id:cate_id}).then(res=>{
					if(res.code==0){
						this.quals = res.data.quals;
						this.old_money = res.data.old_money;
						this.money = res.data.money;
						this.pay_money = res.data.pay_money;
					}
				})
			},
			getInfo() {
				getCateApplyInfo({}).then(res => {
					if(res.code==0){
						this.cate_big = res.data.cate;
						this.cate_fir = res.data.cate[0].categories;
						var cate_one = res.data.cate_one;
						this.quals = cate_one.quals;
						this.qual_index = 0;
						this.cate_index = 0;
						this.old_money = cate_one.old_money;
						this.money = cate_one.money;
						this.pay_money = cate_one.pay_money;
					}
				})
			},
			chose_qual(index,index_){
				this.qual_index = index;
				this.cate_index = index_;
			},
			getfile(response, file){
				var index = this.qual_index;
				var index_ = this.cate_index;
				this.loading = false;
			    if(response.code == noPermissionCode){
				    handleCode(response.code,response.message);
			    }else if(response.code==40000){
					this.$message.error(response.message);
				}else{
					var quals = this.quals;
					quals[index].quals[index_].imgid = response.data.id;
					quals[index].quals[index_].imgurl = response.data.url;
					quals[index].quals[index_].newurl = response.data.new_url;
					this.quals = quals;
				}
			    // this.$refs.upload_img.clearFiles(); //上传成功之后清除历史记录
			},
			//图片上传前验证
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
			
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}
			
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			
			onthecross(){
				this.loading = true;
			},
		},
	};
</script>

<style scoped="scoped">
	.gp-layer-body{
		min-height: 584px;
		background: #FFFFFF;
		border-radius: 4px;
		border-top: 1px solid #EEEEEE;
	}
	
	.cate-apply-main{
		display: flex;
	}
	.cate-apply-one{
		/* width: 50%; */
	}
	.cate-apply-tit{
		padding: 10px 25px;
		height: 17px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 17px;
	}
	.cate-apply-view{
		display: flex;
		margin-left: 20rpx;
	}
	.cate-apply-list{
		width: 231px;
		height: 426px;
		background: #F2F6FC;
		border-radius: 4px;
		overflow-y: auto;
	}
	.cate-apply-item{
		width: 215px;
		height: 32px;
		border-radius: 2px;
		border: 1px solid #F2F6FC;
		padding-left: 5px;
		margin: 10px 0 0 5px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.cate-apply-item-name{
		line-height: 32px;
	}
	.cate-apply-item-icon{
		margin: 0 5px 0 auto;
		width: 16px;
		height: 16px;
		display: block;
	}
	.cate-apply-item-act{
		color: #1989FA;
		border: 1px solid #0486FE;
	}
	.cate-apply-qual{
		display: flex;
		margin-left: 25px;
	}
	.cate-apply-qual-tit{
		width: 115px;
		margin: 8px 0px 8px 0;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 22px;
	}
	
	.cate-apply-qual-right{
		margin-top: 13px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 14px;
	}
	
	.uploader-div {
		width: 90px;
		height: 90px;
		background: #F2F6FC;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}
	
	.uploader-div .el-icon-plus {
		color: #429FFF;
		font-size: 35px;
		font-weight: bold;
	}
	.upload-image {
		position: relative;
		margin-right: 15px;
	}
	
	
	.cate-apply-qual-desc{
		width: 321px;
		height: 51px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
		margin: 10px 0 20px 0;
	}
	.cate-apply-qual-exp{
		color: #0486FE;
	}
	.cate-apply-money{
		border-top: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		height: 80px;
		margin-top: 40px;
	}
	.cate-apply-operate {
		margin-right: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	.cate-apply-money-btn{
		margin: 6px 0px 6px auto;
		width: 162px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		text-align: center;
	}
	.cate-apply-checkbox {
		display: flex;
		align-items: center;
	}
	.cate-apply-checkbox >>> p {
		margin-left: 5px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		color: #999999;
		line-height: 17px;
	}
	.cate-apply-checkbox >>> p span {
		color: #0486FE;
		cursor: pointer;
	}
	.cate-apply-money-info{
		margin: 10px 0 0 20px;
	}
	.cate-apply-money-need{
		font-size: 16px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 29px;
		margin-bottom: 8px;
	}
	.cate-apply-money-need-num{
		font-size: 21px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #F56C6C;
	}
	.cate-apply-money-other{
		display: flex;
	}
	.cate-apply-money-one{
		height: 17px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 17px;
		margin-right: 20px;
	}
	.cover_img{
		width: 90px;
		height: 90px;
		object-fit: cover;
	}
	.check-pay-btn{
		display: block;
		margin: 20px auto;
	}
	
	.my-dialog>>>.el-dialog {
		width: 650px;
	}
	
	.my-dialog>>>.el-dialog__header {
		padding: 15px 15px 0 15px;
		font-size: 18px;
		color: #333333;
		line-height: 30px;
	}
	
	.my-dialog>>>.el-dialog__body {
		padding: 0 15px 15px 15px;
	}
	
	.my-dialog>>>.el-dialog__footer {
		padding: 0 20px 15px 0;
	}
	
	.my-dialog>>>.el-dialog__footer .el-button--primary {
		background-color: #0486FE;
		border-color: #0486FE;
	}
	
	.my-dialog>>>.my-date {
		padding: 5px 0 10px 0;
		font-size: 12px;
		color: #666666;
		line-height: 17px;
	}
	
	.my-editor {
		padding-top: 15px;
		border-top: 1px solid #EEEEEE;
	}
	
	.my-editor>>>.ql-toolbar {
		display: none;
	}
	
	.my-editor>>>.ql-container {
		border: 0;
	}
	
	.my-editor>>>.ql-editor {
		padding: 0;
		height: 445px;
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	
	.my-form_child>>>.el-form-item {
		margin-bottom: 0;
	}
	
	.my-form_child>>>.el-form-item__label {
		color: #999999;
		line-height: 35px;
	}
	
	.my-form_child>>>.el-form-item__content {
		color: #333333;
		line-height: 35px;
	}
	
	.my-form_child>>>.my-button-focus {
		color: #409EFF;
		border-color: #c6e2ff;
		background-color: #ecf5ff;
	}
	
	.my-form_child>>>.my-button:focus,
	.my-form_child>>>.my-button:hover {
		background: #FFF;
		border: 1px solid #DCDFE6;
		color: #606266;
	}
	
	.my-form_child>>>.red-label {
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #F56C6C;
		line-height: 40px;
	}
	
	.my-form_child>>>.flex-label {
		display: flex;
	}
	
	.pay-warn {
		margin-left: 15px;
		font-size: 12px;
		color: #999999;
		line-height: 17px;
	}
	
	.pie {
		display: flex;
		align-items: center;
		margin-top: 15px;
		margin-left: 50px;
	}
	.pie p {
		font-size: 18px;
		color: #333333;
		line-height: 30px;
	}
	
	.put-item {
		margin-top: 16px;
		margin-left: 40px;
		margin-bottom: 0;
		padding: 10px;
		background: #F2F6FC;
		width: 660px;
	}
	
	.put-item p {
		font-size: 12px;
		color: #999999;
		line-height: 20px;
	}
	
	.put-item p:first-child {
		margin-bottom: 6px;
		font-size: 14px;
		color: #666666;
		line-height: 16px;
	}
	
	.put-item .copy {
		margin-left: 20px;
		font-size: 12px;
		color: #1989FA;
		line-height: 17px;
		cursor: pointer;
	}
	.pay-item {
		margin-top: 16px;
		margin-left: 50px;
	}
	
	.my-label {
		padding-bottom: 10px;
		display: flex;
		align-items: center;
	}
	
	.my-label:last-child {
		padding-bottom: 0;
	}
	
	.my-label_title {
		font-size: 14px;
		color: #666666;
		line-height: 22px;
		width: 80px;
	}
	
	.my-label_title span {
		margin-right: 3px;
		font-size: 12px;
		color: #F56C6C;
		line-height: 17px;
	}
	
	.my-label_content {
		margin-left: 27px;
	}
	.pay-dialog>>>.el-dialog__body{
		padding-top: 0;
		padding-right: 0;
	}
	.pay-dialog>>>.el-tabs__header{
		margin-bottom: 0;
	}
	.pay-dialog-money{
		height: 40px;
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 40px;
	}
	
	.money-tips{
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #F56C6C;
		line-height: 17px;
		margin-bottom: 35px;
		margin-left: 106px;
	}
	
	.wxpay-qrcode{
		width: 170px;
		height: 170px;
		margin: 116px auto 0;
	}
	.wxpay-res-div{
		display: flex;
	}
	.wxpay-res{
		display: flex;
		align-items: center;
		margin:0 auto;
	}
	.wxpay-icon{
		width: 40px;
		height: 36px;
		margin-right: 16px;
	}
	.wxpay-txt{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
</style>
